import React from 'react';
import { Helmet } from 'react-helmet-async';

const VehicleMetaTags = ({ carData }) => {
  if (!carData || !carData.car || !carData.carType) return null;

  const { car, carType } = carData;
    let url = "", title = "", price = "", carImages = [], id = "", description = "";
  // Required meta info
  if (carType === "local") {
    url = `https://bidcaribbean.co/local-vehicle-detail/${car.id}`;
    price = car.buyNowPrice ? car.buyNowPrice : car.currentBid;
    carImages = car.carImages;
    id = car.id;

    // Build description with all local car attributes
    description = `
      Make: ${car.make || ""}
      Model: ${car.model || ""}
      Year: ${car.year || ""}
      Mileage: ${car.mileage || ""}
      Transmission: ${car.transmission || ""}
      Location: ${car.location || ""}
      Status: ${car.status || ""}
      Auction Date: ${car.auction_date || ""}
      Buy Now Price: ${car.buyNowPrice || ""}
      Current Bid: ${car.currentBid || ""}
      No Of Bids: ${car.noOfBids || ""}
      VIN: ${car.vin || ""}
    `.replace(/^\s+|\s+$/gm, ""); // Remove leading/trailing spaces per line
  } else {
    url = `https://bidcaribbean.co/vehicle-detail/${car.lot_id}`;
    price = car.price_new ? car.price_new : car.currentBid;
    carImages = car.link_img_hd ? car.link_img_hd : car.link_img_small;
    id = car.lot_id;

    // Build description with all import car attributes
    description = `
      Title: ${car.title || ""}
      Series: ${car.series || ""}
      Odometer: ${car.odometer || ""}
      Color: ${car.color || ""}
      Transmission: ${car.transmission || ""}
      Drive: ${car.drive || ""}
      Engine: ${car.engine || ""}
      Engine Size: ${car.engine_size || ""}
      Vehicle Type: ${car.vehicle_type || ""}
      Auction Type: ${car.auction_type || ""}
      State: ${car.state || ""}
      Country: ${car.country || ""}
      Body Type: ${car.body_type || ""}
      Fuel: ${car.fuel || ""}
      Status: ${car.status || ""}
      VIN: ${car.vin || ""}
      Keys: ${car.keys || ""}
      Price New: ${car.price_new || ""}
      Current Bid: ${car.current_bid || car.currentBid || ""}
      Auction Date: ${car.auction_date || ""}
      Location: ${car.location || ""}
    `.replace(/^\s+|\s+$/gm, "");
  }
  title = `${car.make || ''} ${car.model || ''} ${car.year || ''}`.trim();

  return (
    <>
      <Helmet>        
          {/* Open Graph / Facebook */}
          <meta property="og:title" content={title} />
          <meta property="og:url" content={url} />
          <meta property="og:image" content={carImages[0]} />


          {/* JSON-LD microdata for Meta Catalog */}
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org/",
              "@type": "Product",
              "name": title,
              "image": carImages,
              "url": url,
              "sku": id,  // <-- Meta reads SKU or productID as the item ID
              "description": description,
              "brand": {
                "@type": "Brand",
                "name": car.make
              },
              "model": car.model,
              "productionDate": car.year,
              "offers": {
                "@type": "Offer",
                "priceCurrency": "USD",
                "price": price,
                "availability": "InStock"
              }
            })}
          </script>
      </Helmet>
    </>
  );
};

export default VehicleMetaTags;